import React, { useState, useEffect, useCallback } from 'react';
import { Edit } from 'lucide-react';
import { equipmentAPI } from '../../services/api';
import { format } from 'date-fns';
import AddService from './AddService';

const TYPE_COLORS = { ROUTINE: 'bg-emerald-100 text-emerald-700', REPAIR: 'bg-amber-100 text-amber-700', EMERGENCY: 'bg-red-100 text-red-700' };

export default function ServiceHistory({ equipmentId, onRefresh }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  const fetchList = useCallback(() => {
    setLoading(true);
    equipmentAPI.getServiceHistory(equipmentId)
      .then((res) => setList(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [equipmentId]);

  useEffect(() => { fetchList(); }, [fetchList]);

  const handleSaved = () => {
    setEditing(null);
    fetchList();
    onRefresh?.();
  };

  if (loading) return <div className="py-8 text-center text-gray-500">Loading...</div>;
  if (list.length === 0) return <div className="py-8 text-center text-gray-500">No service records</div>;

  return (
    <>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Date</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Type</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Description</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Cost</th>
              <th className="text-right py-3 px-4 font-semibold text-gray-700 w-16"></th>
            </tr>
          </thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id} className="border-t border-gray-100 hover:bg-gray-50 transition-colors">
                <td className="py-3 px-4">{s.service_date ? format(new Date(s.service_date), 'dd MMM yyyy') : '-'}</td>
                <td className="py-3 px-4">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${TYPE_COLORS[s.service_type] || 'bg-gray-100'}`}>
                    {s.service_type}
                  </span>
                </td>
                <td className="py-3 px-4 text-gray-600">{s.description || '-'}</td>
                <td className="py-3 px-4 font-medium">₹{s.service_cost ? Number(s.service_cost).toLocaleString() : '-'}</td>
                <td className="py-3 px-4 text-right">
                  <button
                    onClick={() => setEditing(s)}
                    className="p-1.5 text-gray-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-colors"
                    title="Edit service"
                  >
                    <Edit className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <AddService
          equipmentId={equipmentId}
          existingService={editing}
          onClose={() => setEditing(null)}
          onSaved={handleSaved}
        />
      )}
    </>
  );
}
